module.exports = __webpack_public_path__ + "static/resize-bbc9d4ce231c1e39de1cb8aff3ba9b44.mp4";